export default class StaticAnnouncementBar {
  constructor(section) {}
}
